import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AngularPaths, Module, Permission } from '@models/index.model';
import { ModulesService, PermissionsService, SessionService } from '@services/index.service';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class DefaultRouteGuard  {
  public constructor(
    private _router: Router,
    private _appModules: ModulesService,
    private _permiss: PermissionsService,
    private _session: SessionService
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // El usuario tiene token. Redirigir dentro de la aplicación.
    if (this._session.checkTokenValid()) {
      return this._router.parseUrl(
        this._appModules.hasModule(Module.WEB_SIGNATURE) && this._permiss.hasPermiss(Permission.WEB_SIGNATURE)
          ? AngularPaths.SIGNTRUST
          : AngularPaths.CERTIFICATES
      );
    }

    if (!this._session.checkTokenValid() && !route.url.join('/').includes(AngularPaths.LOGIN)) {
      return this._router.parseUrl(AngularPaths.LOGIN);
    }

    return true;
  }
}
